import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  baseUrl: string;
  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl + 'api/';
  }

  getEntityHistory(type: string, id: number) {
    const url = this.baseUrl + type + '/' + String(id) + '/history';
    return this.httpClient.get<History[]>(url, { params: new HttpParams(), observe: 'response' });
  }
}
